import React, { useLayoutEffect, useRef } from 'react';

interface AgricoProjectIframeProps {
  theme?: string;
}

const AgricoProject: React.FC<AgricoProjectIframeProps> = ({ theme = 'light' }) => {
  const iframeRef = useRef<HTMLIFrameElement>(null);

  useLayoutEffect(() => {
    window.scrollTo(0, 0);

    // Force light mode for Agrico project - runs synchronously before paint
    document.body.className = 'light';

    // Hide body overflow to prevent double scrollbar
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    // Update iframe theme to light
    const updateIframeTheme = () => {
      if (iframeRef.current?.contentWindow) {
        iframeRef.current.contentWindow.postMessage(
          { theme: 'light' },
          '*'
        );
      }
    };

    // Initial theme update
    const timer = setTimeout(updateIframeTheme, 100);

    // Restore the app's real theme (not a snapshot) and overflow on unmount
    return () => {
      clearTimeout(timer);
      document.body.className = theme;
      document.body.style.overflow = previousOverflow;
    };
  }, [theme]);

  return (
    <iframe
      ref={iframeRef}
      src="/agrico/index.html"
      style={{
        width: '100%',
        height: '100vh',
        border: 'none',
        display: 'block'
      }}
      title="Agrico Case Study"
      onLoad={() => {
        if (iframeRef.current?.contentWindow) {
          iframeRef.current.contentWindow.postMessage(
            { theme: 'light' },
            '*'
          );
        }
      }}
    />
  );
};

export default AgricoProject;
